module.exports = __webpack_public_path__ + "static/media/fixed_voice_info_close_remove.5046821f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_info_close_remove.svg
// module id = 3213
// module chunks = 0